export const ruleSetSingleWallHingedOrOpen = {
    500: [500],
    750: [750],
    1000: [1000],
    1250: [750, 500],
    1500: [1000, 500],
    1750: [1000, 750],
    2000: [1000, 1000],
    2250: [1000, 750, 500],
    2500: [1000, 1000, 500],
    2750: [1000, 1000, 750],
    3000: [1000, 1000, 1000],
    3250: [1000, 1000, 750, 500],
    3500: [1000, 1000, 1000, 500],
    3750: [1000, 1000, 1000, 750],
    4000: [1000, 1000, 1000, 1000]
};
//# sourceMappingURL=RuleSetSingleWallHingedOrOpen.js.map